window.addEventListener("DOMContentLoaded", () => {
  // Function to get a parameter by name from the URL
  const getQueryParam = (name) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  };

  // Function to store the values in sessionStorage
  const storeInSessionStorage = (key, value) => {
    if (value) {
      sessionStorage.setItem(key, value);
    }
  };

  // Function to get the value from sessionStorage
  const getFromSessionStorage = (key) => {
    return sessionStorage.getItem(key);
  };

  // Get the campaign ID and ad group ID from the URL
  const campaignId = getQueryParam("utm_campaign");
  const adgroup = getQueryParam("adgroup"); // Corrected from 'adgroupid' to 'adgroup'

  // If campaignId or adgroup are found in the URL, store them in sessionStorage
  if (campaignId) {
    storeInSessionStorage("utm_campaign", campaignId);
  }
  if (adgroup) {
    storeInSessionStorage("adgroup", adgroup);
  }

  // Get the stored campaignId and adgroup from sessionStorage
  const storedCampaignId = getFromSessionStorage("utm_campaign");
  const storedAdgroup = getFromSessionStorage("adgroup");

  // Populate all inputs with class '.campaign-input' with the campaign ID from sessionStorage
  if (storedCampaignId) {
    document.querySelectorAll(".campaign-input").forEach((input) => {
      input.value = storedCampaignId;
    });
  }

  // Populate all inputs with class '.adgroup-input' with the ad group ID from sessionStorage
  if (storedAdgroup) {
    document.querySelectorAll(".adgroup-input").forEach((input) => {
      input.value = storedAdgroup;
    });
  }

  // Also update the cart with these values if they exist
  if (storedCampaignId || storedAdgroup) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          utm_campaign: storedCampaignId || "No Campaign",
          adgroup: storedAdgroup || "No AdGroup",
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Cart updated with UTM campaign and adgroup:", data);
      })
      .catch((error) => {
        console.error(
          "Error updating cart with UTM campaign and adgroup:",
          error
        );
      });
  }

  // Get all instances of .footer__block--menu
  const footerBlocks = document.querySelectorAll(".footer__block--menu");

  // Check if there is a second instance
  if (footerBlocks.length > 1) {
    const secondFooterBlock = footerBlocks[1]; // Get the second instance

    // Target all <a> tags within the second instance and set target="_blank"
    const links = secondFooterBlock.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });
  }

  // Add click event listener for all .dropdown-menu__item elements and override existing listeners
  const menuItems = document.querySelectorAll(".dropdown-menu__item");
  menuItems.forEach((item) => {
    item.addEventListener(
      "click",
      function (event) {
        // Prevent any other click event listeners from being executed
        event.stopImmediatePropagation();

        const url = item.getAttribute("data-url");
        if (url) {
          window.open(url, "_blank");
        }
      },
      true
    ); // The third parameter 'true' ensures this listener gets priority
  });

  //Make nav links open in new page
  const links = document.querySelectorAll(
    ".header__link-list li:nth-of-type(2) .dropdown-menu a"
  );
  links.forEach(function (link) {
    link.setAttribute("target", "_blank");
  });

  //Logic to open chat on chat trigger
  const chatTriggers = document.querySelectorAll(".chat-trigger");
  chatTriggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      document.querySelector(".zsiq_floatmain").click();
    });
  });

  //Date picket + time select logic

  const timeSelect = document.querySelector('select[name="time"]');
  const dateInput = document.querySelector('input[name="date"]');

  // Function to generate time options from 9 AM to 4 PM
  function generateTimeOptions(minTime = "09:00") {
    const options = [];
    const startHour = 9;
    const endHour = 16; // 4 PM is the last option
    for (let hour = startHour; hour <= endHour; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        // Only add 4:00, not 4:30 or beyond
        if (hour === endHour && minute > 0) break;
        const timeString = `${hour.toString().padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")}`;
        const timeValue = `${timeString}`;
        // Only add options that are later than the minimum time
        if (timeValue >= minTime) {
          options.push(timeValue);
        }
      }
    }
    return options;
  }

  // Disable weekends in the date picker
  function isWeekend(date) {
    const day = date.getDay();
    return day === 6 || day === 0; // 6 is Saturday, 0 is Sunday
  }

  // Update time options based on the selected date
  function updateTimeOptions(selectedDate) {
    const now = new Date();
    const selected = new Date(selectedDate);

    // If selected date is today, apply the 2-hour rule
    if (selected.toDateString() === now.toDateString()) {
      let minHour = now.getHours() + 2; // 2 hours ahead of the current hour
      const minMinute = now.getMinutes();
      let minTime = `${minHour.toString().padStart(2, "0")}:${
        minMinute >= 30 ? "30" : "00"
      }`;

      if (minHour >= 16) {
        timeSelect.innerHTML =
          '<option value="">No times available for today</option>';
        return;
      }

      const timeOptions = generateTimeOptions(minTime);
      populateTimeSelect(timeOptions);
    } else {
      // If the date is in the future, show all time slots from 9 AM to 4 PM
      const timeOptions = generateTimeOptions();
      populateTimeSelect(timeOptions);
    }
  }

  // Populate time select with the given options
  function populateTimeSelect(timeOptions) {
    timeSelect.innerHTML = '<option value="">Select a time</option>';
    timeOptions.forEach((option) => {
      const opt = document.createElement("option");
      opt.value = option;
      opt.textContent = option;
      timeSelect.appendChild(opt);
    });
  }

  // Set the minimum selectable date to today and disable weekends
  function setDatePickerRestrictions() {
    const today = new Date();
    const formattedToday = today.toISOString().split("T")[0];
    dateInput.setAttribute("min", formattedToday);

    // Disable weekends by checking input date
    dateInput.addEventListener("change", function () {
      const selectedDate = new Date(this.value);
      if (isWeekend(selectedDate)) {
        alert("Weekends are not available. Please select a weekday.");
        dateInput.value = ""; // Clear the selected date
        timeSelect.innerHTML = '<option value="">No times available</option>'; // Clear times
      } else {
        updateTimeOptions(this.value); // Repopulate time options based on the selected date
      }
    });
  }

  setDatePickerRestrictions();
  updateTimeOptions(new Date()); // Run the initial time update for today's date

  //Logic to open tab on product page when selected
  // Select all elements with the class '.product-info__button'
  const productButtons = document.querySelectorAll(".product-info__button");

  // Add a click event listener to each product button
  productButtons.forEach((button) => {
    button.addEventListener("click", function () {
      // Get the innerText of the clicked button and convert it to lowercase
      const clickedButtonText = this.innerText.toLowerCase();

      // Select all elements with the class '.tabs-nav__button'
      const tabButtons = document.querySelectorAll(".tabs-nav__button");

      // Loop through each tab button and check if its innerText matches the clicked button's innerText
      tabButtons.forEach((tabButton) => {
        if (tabButton.innerText.toLowerCase() === clickedButtonText) {
          // Programmatically click the tab button if it matches
          tabButton.click();
        }
      });
    });
  });

  //Modal Opening Logic

  const contactModal = document.getElementById("contactModal");

  // Function to switch the tab inside the modal
  function switchModalTab(tab) {
    // Hide all tabs first
    document
      .querySelectorAll(".w-tab-pane")
      .forEach((pane) => pane.classList.remove("active"));

    // Remove active class from all tabs
    document
      .querySelectorAll(".modal-tabs-menu .tab-pill")
      .forEach((tabLink) => tabLink.classList.remove("active"));

    // Show the specific tab based on the `data-modal-trigger` value
    if (tab === "demo") {
      document.querySelector("#demo").classList.add("active");
      document.querySelector(".booking.demo-tab").classList.add("active");
    } else if (tab === "call") {
      document.querySelector("#call").classList.add("active");
      document.querySelector(".call-tab").classList.add("active");
    } else if (tab === "message") {
      document.querySelector("#message").classList.add("active");
      document.querySelector(".email-tab").classList.add("active");
    }
  }

  // Code for triggering modal with .modal-trigger elements
  document.querySelectorAll(".modal-trigger").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent default link behavior

      const modalTriggerValue = trigger.getAttribute("data-modal-trigger");
      if (modalTriggerValue) {
        switchModalTab(modalTriggerValue); // Switch to the correct tab based on data-modal-trigger value
      }

      // Open the modal
      contactModal.style.display = "flex";

      const currentUrl = window.location.href;
      const urls = document.querySelectorAll(".url-input");
      urls.forEach((input) => {
        input.value = currentUrl;
      });
    });
  });

  // New code to trigger the modal with the 4th `li` link in the header
  const fourthLinkHeader = document.querySelector(
    ".header__link-list li:nth-child(4) a"
  );
  if (fourthLinkHeader) {
    fourthLinkHeader.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent the default link behavior
      switchModalTab("message"); // Show the message tab by default for the header link
      contactModal.style.display = "flex"; // Show the modal
      const currentUrl = window.location.href;
      const urls = document.querySelectorAll(".url-input");
      urls.forEach((input) => {
        input.value = currentUrl;
      });
    });
  }

  // New code to trigger the modal with the 4th `li` link in the third .footer__block--menu
  const thirdFooterMenu = document.querySelectorAll(".footer__block--menu")[2]; // Select the third .footer__block--menu
  if (thirdFooterMenu) {
    const fourthLinkFooter = thirdFooterMenu.querySelector(
      "ul li:nth-child(4) a"
    ); // Target the 4th li a in the ul
    if (fourthLinkFooter) {
      fourthLinkFooter.addEventListener("click", (event) => {
        event.preventDefault(); // Prevent the default link behavior
        switchModalTab("message"); // Show the message tab for the footer link
        contactModal.style.display = "flex"; // Show the modal
        const currentUrl = window.location.href;
        const urls = document.querySelectorAll(".url-input");
        urls.forEach((input) => {
          input.value = currentUrl;
        });
      });
    }
  }

  //Modal closing Logic
  document.getElementById("closeModal").addEventListener("click", function () {
    document.getElementById("contactModal").style.display = "none";
  });

  //Tab switching Logic

  document.querySelectorAll(".tab-pill").forEach(function (tab) {
    tab.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelectorAll(".tab-pill").forEach(function (t) {
        t.classList.remove("active");
      });
      document.querySelectorAll(".w-tab-pane").forEach(function (pane) {
        pane.classList.remove("active");
      });

      this.classList.add("active");
      const targetTab = this.getAttribute("data-tab");
      document.getElementById(targetTab).classList.add("active");
    });
  });

 
  // Phone number reveal
  document
    .getElementById("phone-partial")
    .addEventListener("click", function () {
      document.getElementById("phone-partial").style.display = "none";
      document.getElementById("phone-full").style.display = "inline";
      trackConversion("phone"); // Call tracking function
    });

  // Email reveal
  document
    .getElementById("email-partial")
    .addEventListener("click", function () {
      document.getElementById("email-partial").style.display = "none";
      document.getElementById("email-full").style.display = "inline";
      trackConversion("email"); // Call tracking function
    });

  // Conversion tracking function
  function trackConversion(type) {
    console.log(`${type} full info was revealed`);
    // Integrate with your analytics system here
  }
});
